export default {_name:'card.simple',module:'Field',view:'Element/Card',webOptions:{xs:12},mobileOptions:{ms:12}}